import { useContext } from 'react';
import { BackendDispatchContext } from '../context/backend-context';
import { FeatureFlag, TicketFilter } from '@nimey/podcast-global-entity';
import { useEntityList } from './use-entity-list';

export const useFeatureUserList = (flag: FeatureFlag) => {
  const { asyncActions } = useContext(BackendDispatchContext)

  return useEntityList(flag, 'user', asyncActions!.loadFeatureUserList.bind(asyncActions!))
}